import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'tzdate',
    standalone: false
})
export class TzdatePipe implements PipeTransform {
  transform(date: string | null) {
    return date ? date.replace(' ', 'T') : date;
  }
}
